import { useEffect, useState } from 'react';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore, createHook } from '@atlassian/react-sweet-state';
import { actions } from './actions/index.tsx';
import type { State } from './types.tsx';

export type Actions = typeof actions;

export const initialState: State = {} as const;

const store = createStore<State, Actions>({
	name: 'jsw-customer-template-project-properties',
	initialState,
	actions,
});

export const useProjectPropertiesService = createHook(store);

export const useLastFetchedProjectProperties = createHook(store, {
	selector: (state: State, projectId?: string) => {
		if (!projectId || !state[projectId] || state[projectId].fetchStatus === 'fetching') {
			return null;
		}
		return state[projectId];
	},
});

export const useProjectProperties = (projectId?: string) => {
	const [lastFetchedProjectProperties] = useLastFetchedProjectProperties(projectId);
	const defaultProjectPropertiesState = {
		isCustomerTemplateProject: false,
		templateKey: '',
	};
	const [projectProperties, setProjectProperties] = useState(
		lastFetchedProjectProperties || defaultProjectPropertiesState,
	);

	useEffect(() => {
		if (
			!lastFetchedProjectProperties ||
			projectProperties.templateKey === lastFetchedProjectProperties.templateKey
		) {
			return;
		}

		setProjectProperties(lastFetchedProjectProperties);
	}, [lastFetchedProjectProperties, projectId, projectProperties.templateKey]);

	return projectProperties;
};
